const phone = v => {
  if (typeof v !== 'string') {
    return false;
  }

  const parts = v.match(/^\+?[1-9]\d{1,14}$/);
  return parts !== null;
};

const passportSeries = (value) => {
  return !!value && !!value.match(/^(\d{4}|\w{2})$/);
};

const passportID = (value, vm) => {
  const validSeries = !vm.$v.passportSeries.$invalid;
  let validId = false;

  if (validSeries) {
    validId = !!value && !!(vm.passportSeries.length === 2 ? value.match(/^\d{7}$/) : value.match(/^\d{6}$/));
  }

  return validId;
};

export * from 'vuelidate/lib/validators'

export { phone, passportSeries, passportID }
